'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  IconScan,
  IconPrinter,
  IconBarcode,
  IconFileText,
  IconFileTypePdf
} from '@tabler/icons-react';
import { ScannerSimulator } from './scanner-simulator';
import { PrinterSimulator } from './printer-simulator';
import { BarcodeSimulator } from './barcode-simulator';
import { ContainerGenerator } from './container-generator';
import { TestPdfForm } from './test-pdf-form';
import type { DevTool } from '../types';

export function DevToolsTabs() {
  const t = useTranslations('devTools.tabs');
  const [active, setActive] = useState<DevTool>('scanner');

  return (
    <Tabs
      value={active}
      onValueChange={(value) => setActive(value as DevTool)}
      className='w-full'
    >
      <TabsList className='h-10'>
        <TabsTrigger value='scanner'>
          <IconScan className='size-4' />
          {t('scanner')}
        </TabsTrigger>
        <TabsTrigger value='printer'>
          <IconPrinter className='size-4' />
          {t('printer')}
        </TabsTrigger>
        <TabsTrigger value='barcode'>
          <IconBarcode className='size-4' />
          {t('barcode')}
        </TabsTrigger>
        <TabsTrigger value='containers'>
          <IconFileText className='size-4' />
          {t('containers')}
        </TabsTrigger>
        <TabsTrigger value='pdf'>
          <IconFileTypePdf className='size-4' />
          {t('pdf')}
        </TabsTrigger>
      </TabsList>
      <TabsContent value='scanner' className='mt-4'>
        <ScannerSimulator />
      </TabsContent>
      <TabsContent value='printer' className='mt-4'>
        <PrinterSimulator />
      </TabsContent>
      <TabsContent value='barcode' className='mt-4'>
        <BarcodeSimulator />
      </TabsContent>
      <TabsContent value='containers' className='mt-4'>
        <ContainerGenerator />
      </TabsContent>
      <TabsContent value='pdf' className='mt-4'>
        <TestPdfForm />
      </TabsContent>
    </Tabs>
  );
}
